import { render, staticRenderFns } from "./UserQuestion.vue?vue&type=template&id=5748d3bb&scoped=true"
import script from "./UserQuestion.vue?vue&type=script&lang=js"
export * from "./UserQuestion.vue?vue&type=script&lang=js"
import style0 from "./UserQuestion.vue?vue&type=style&index=0&id=5748d3bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5748d3bb",
  null
  
)

export default component.exports